// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/tablets.js';

import { paths } from '../generated/tablets';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('tablets', Original, paths);
